let orderNumInput;
let orderError;
let orderRequired;
let emailInput;
let emailError;
let emailRequired;
let zipInput;
let zipError;
let zipRequired;

function initElementObjects() {
  orderNumInput = document.getElementById('OrderNumber');
  emailInput = document.getElementById('CustomerEmail');
  zipInput = document.getElementById('ZipCode');

  orderError = document.getElementById('order_error');
  orderRequired = document.getElementById('order_required');
  emailError = document.getElementById('email_error');
  emailRequired = document.getElementById('email_required');
  zipError = document.getElementById('zip_error');
  zipRequired = document.getElementById('zip_required');

  submitButton = document.getElementById('submit_button');
}

const returnsApiUrl = 'https://spo-partner-api.azure-api.net/returns';
const orderRegex = (/test|localhost/.test(returnsApiUrl) ? /^SPOTEST[0-9]+$/i : /^SPO[0-9]+$/i);
const emailRegex = /^\w+([\.\+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const zipRegex = /^[0-9]{5}$/;

function validateForSubmit() {
  let orderValidationError = false;
  const orderNum = orderNumInput.value;
  if (!orderNum) {
    orderValidationError = true;
    orderRequired.classList.remove('hide');
  } else if (!orderRegex.test(orderNum)) {
    orderValidationError = true;
    orderError.classList.remove('hide');
  }
  if (orderValidationError) {
    orderNumInput.classList.add('error');
  } else {
    orderNumInput.classList.remove('error');
    orderRequired.classList.add('hide');
    orderError.classList.add('hide');
  }

  let emailValidationError = false;
  const email = emailInput.value;
  if (!email) {
    emailValidationError = true;
    emailRequired.classList.remove('hide');
  } else if (!emailRegex.test(email)) {
    emailValidationError = true;
    emailError.classList.remove('hide');
  }
  if (emailValidationError) {
    emailInput.classList.add('error');
  } else {
    emailInput.classList.remove('error');
    emailRequired.classList.add('hide');
    emailError.classList.add('hide');
  }

  let zipValidationError = false;
  const zip = zipInput.value;
  if (!zip) {
    zipValidationError = true;
    zipRequired.classList.remove('hide');
  } else if (!zipRegex.test(zip)) {
    zipValidationError = true;
    zipError.classList.remove('hide');
  }
  if (zipValidationError) {
    zipInput.classList.add('error');
  } else {
    zipInput.classList.remove('error');
    zipRequired.classList.add('hide');
    zipError.classList.add('hide');
  }

  return !(orderValidationError || emailValidationError || zipValidationError);
}

function toggleInputsDisabled(disabled) {
  submitButton.disabled = disabled;

  emailInput.disabled = disabled;
  orderNumInput.disabled = disabled;
  zipInput.disabled = disabled;
}

function findTheOrder() {
  initElementObjects();
  let formFeedback = document.getElementById('form_feedback');
  formFeedback.classList.add('hide');
  document.getElementById('not_found').classList.add('hide');
  document.getElementById('generic_error').classList.add('hide');
  submitButton.disabled = true;

  const orderNum = orderNumInput.value;
  const email = emailInput.value;
  const zip = zipInput.value;

  if (!validateForSubmit()) {
    formFeedback.classList.remove('hide');
    toggleInputsDisabled(false);
    return false;
  }
  toggleInputsDisabled(true);

  const apiUrl = 'https://spo-partner-api.azure-api.net/returns';
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Ocp-Apim-Subscription-Key': '9f624633f2d34123aa12144e37dfdc0a',
    }
  };

  const url = `${apiUrl}/orders?orderNum=${encodeURIComponent(orderNum.toUpperCase())}&email=${encodeURIComponent(email)}&zip=${encodeURIComponent(zip)}`;

  fetch(url, opts)
    .then((response) => mergeStatusAndJsonBody(response))
    .then((response) => {
      const { ok, status, statusText, jsonBody } = response;
      if (ok) {
        return jsonBody;
      }
      formFeedback.classList.remove('hide');
      if (status === 404) {
        document.getElementById('not_found').classList.remove('hide');
        throw new Error('Order not found');
      } else {
        document.getElementById('generic_error').classList.remove('hide');
        const e = new Error(statusText);
        e.responseBody = jsonBody;
        throw e;
      }
    })
    .then((order) => {
      const { id: orderId } = order;
      openModalIframe('Manage Order', `https://spo-returns.azureedge.net?orderId=${orderId}`);
    })
    .catch((error) => console.error(error))
    .finally(() => toggleInputsDisabled(false));

  return false;
}
